export const validateCareerForm = (formData) => {
  const errors = {};

  // UserName validation
  if (!formData.UserName.trim()) {
    errors.UserName = "Full name is required";
  }

  // ContactNumber validation
  if (!formData.ContactNumber || formData.ContactNumber.trim().length < 1) {
    errors.ContactNumber = "Contact number is required.";
  } else if (!/^\d{1,15}$/.test(formData.ContactNumber)) {
    errors.ContactNumber =
      "Contact number must be a valid numeric value with up to 15 digits.";
  }

  // EmailAddress validation
  if (!formData.EmailAddress.trim()) {
    errors.EmailAddress = "Email is required";
  } else if (
    !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(formData.EmailAddress)
  ) {
    errors.EmailAddress = "Enter a valid email address";
  }

  // WorkAvailability validation
  if (!formData.WorkAvailability.trim()) {
    errors.WorkAvailability = "Work availability is required";
  }

  // Locality validation
  if (!formData.Locality.trim()) {
    errors.Locality = "Locality is required";
  }

  // ExpectedSalary validation
  if (!formData.ExpectedSalary.trim()) {
    errors.ExpectedSalary = "Expected salary is required";
  }

  // Comments validation
  if (!formData.Comments.trim()) {
    errors.Comments = "Comments are required";
  }

  // ResumeFile validation
  if (!formData.ResumeFile) {
    errors.ResumeFile = "Resume file is required";
  }

  return errors;
};
